<div class="header-navigation-wrapper">
  <div id="welcome-wrapper">
    <h2 id="hello-text">
      <div class="desktop">Bonjour {{dietName}}, ravi de vous revoir 👋</div>
    </h2>
    <div class="actions-wrapper">

      <div class="dropdown" dropdown #dropdown="bs-dropdown" (click)="$event.stopPropagation()">
        <button [class.badged]="notifications && notifications.length > 0"
                class="notifications-button btn btn-outline-primary btn-outline icon-only"
                dropdownToggle type="button">
          <ng-container *ngIf="isLoadingNotifications else notificationsButton">
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            <span class="visually-hidden">Chargement...</span>
          </ng-container>
          <ng-template #notificationsButton>
            <i class="iconly-Notification"></i>
          </ng-template>
        </button>
        <div class="dropdown-backdrop fade" (click)="dropdown.hide()"></div>
        <ul *dropdownMenu role="menu" class="dropdown-menu dropdown-menu-right dropdown-notification">
          <ng-container *ngIf="notifications && notifications.length > 0; else emptyTemplate">
            <li (onMarkAsRead)="markAsRead(notification)"
                (onAdditionalButton)="openPatient($event)"
                *ngFor="let notification of notifications"
                [additionalButton]="(notification.type === 'patient_birthday'
                || notification.type === 'survey_updated'
                || notification.type === 'patient_msdp_created'
                || notification.type === 'appointment_msdp_created')
                ? 'Fiche patient'
                : undefined"
                [additionalPayload]="notification.payload"
                [content]="notification.message"
                [date]="notification.createdAt"
                [loading]="notification === markingAsReadNotification"
                [title]="notification.title"
                class="notification-cell"
                msd-notification-cell></li>
            <li style="text-align: center;">
              <button type="button" class="btn btn-link mark-as-read-button" (click)="markAsReadAll()">
                <ng-container *ngIf="loadingMarkAsReadAll else markAsReadTemplate">
                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                  <span class="visually-hidden">Chargement...</span>
                </ng-container>
                <ng-template #markAsReadTemplate>
                  Marquer tout comme lu
                </ng-template>
              </button>
            </li>
          </ng-container>
          <ng-template #emptyTemplate>
            <li class="empty-notification-label">Aucune notification 🎉</li>
          </ng-template>
        </ul>
      </div>

      <button (click)="openPatientCreationModal()"
              class="add-patient-button btn btn-primary btn-gradient"
              type="button">
        <span>Nouveau patient </span>
        <i i-bs name="plus" width="20" height="20"></i>
      </button>

      <div id="patient-list-type-dropdown" class="dropdown" dropdown container="body">
        <button id="list-filter-button" type="button" class="btn btn-outline-primary btn-outline text-icon"
                dropdownToggle>
          {{getSortListTypeName()}}
          <i class="iconly-Arrow-Down-2"></i>
        </button>
        <div class="dropdown-backdrop fade"></div>
        <ul #dropdown *dropdownMenu class="dropdown-menu dropdown-group" role="menu">
          <li role="menuitem" (click)="updateSortListType(SortListType.All)"><span class="dropdown-item">Tous les
              patients</span></li>
          <li role="menuitem" (click)="updateSortListType(SortListType.Archived)"><span class="dropdown-item">Patients
              archivés</span></li>
          <ng-container *ngIf="groups && groups.length > 0">
            <hr />
            <li role="menuitem" *ngFor="let group of groups"
                (click)="updatePatientGroup(group); updateSortListType(SortListType.Group)"><span
              class="dropdown-item group-cell">{{group.name}}</span>
            </li>
          </ng-container>
          <li class="divider dropdown-divider"></li>
          <li role="menuitem"><span id="cancel-link" class="dropdown-item action">Annuler</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <msd-segmented-navigation #tabs [items]="segmentedItems"></msd-segmented-navigation>
</div>
<hr />

<div id="content-wrapper">
  <router-outlet></router-outlet>
</div>
